module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/450.9943e280.png";